import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useScrollSpy = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const sections = [
      { id: 'inicio', path: '/' },
      { id: 'servicios', path: '/servicios' },
      { id: 'nosotros', path: '/nosotros' },
      { id: 'testimonios', path: '/testimonios' },
      { id: 'contacto', path: '/contacto' }
    ];

    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const section = sections.find(s => s.id === entry.target.id);
          if (section && location.pathname !== section.path) {
            navigate(section.path, { replace: true });
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Note: sections, observer, element, entries are local variables created inside the effect
    // They don't need to be in dependencies. Only navigate and location.pathname are external.
  }, [navigate, location.pathname]);
};
